import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Loader2, RefreshCw } from "lucide-react";

const fmt = (iso) => { try { return new Date(iso).toLocaleString("pt-BR"); } catch { return iso; } };

export const useFaceppStorage = (schoolId) => {
  const [st, setSt] = useState(null);
  const [checking, setChecking] = useState(false);
  const load = useCallback((force = false) => {
    setChecking(true);
    return api.get("/integrations/face/storage-status", { params: { ...(schoolId ? { school_id: schoolId } : {}), ...(force ? { force: true } : {}) } })
      .then((r) => setSt(r.data)).catch(() => setSt(null)).finally(() => setChecking(false));
  }, [schoolId]);
  useEffect(() => { load(); }, [load]);
  return { st, checking, blocked: !!st && !(st.configured && st.ok), recheck: () => load(true) };
};

export const FaceppBlockBanner = ({ st, blocked, checking, onRecheck }) => {
  if (!blocked) return null;
  return (
    <div className="mb-4 flex gap-3 rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900" role="alert" data-testid="facepp-block-banner">
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" />
      <div className="flex-1">
        <b>{st.configured ? "O CompreFace desta escola está recusando guardar rostos" : "CompreFace não configurado para esta escola"}</b>
        <p className="mt-1">{st.configured ? "Os botões de cadastro de biometria ficam desativados até o servidor CompreFace voltar a aceitar rostos. Confira se o servidor está no ar e se a chave é do serviço de Recognition (Integrações)." : "O SUPERADMIN precisa informar a URL e a chave do CompreFace da escola em Integrações."}</p>
        {st.configured && <p className="mt-1 text-xs text-amber-700" data-testid="facepp-block-detail">{st.message}{st.at ? ` · verificado em ${fmt(st.at)}` : ""}</p>}
        {st.configured && <Button size="sm" variant="outline" className="mt-2 border-amber-400 bg-white" disabled={checking} onClick={onRecheck} data-testid="facepp-block-recheck">
          {checking ? <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="mr-1 h-3.5 w-3.5" />}Verificar agora</Button>}
      </div>
    </div>
  );
};
